<template>
  <div>
    <VDropdown ref="dropdown" right>
      <template #button="{ open }">
        <BaseButton primary @click="open"> New Agency Offer </BaseButton>
      </template>

      <div
        class="origin-top-right absolute right-0 mt-2 w-56 rounded shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        <div class="py-1">
          <CreateAgencyOfferLine
            v-for="agency in agencies"
            :key="agency.id"
            :agency="agency"
            @create-offer="createOffer"
          />
        </div>
      </div>
    </VDropdown>
    <OfferCreateModalForm
      v-if="offerCreateModalFormProps"
      ref="offerCreateModal"
      v-bind="offerCreateModalFormProps"
      without-button
      class="w-full"
      @success="$emit('created')"
      @hide="offerCreateModalFormProps = null"
    />
  </div>
</template>

<script>
import OfferCreateModalForm from 'Forms/OfferModalForm/Create.vue';
import VDropdown from 'Components/Common/VDropdown.vue';
import CreateAgencyOfferLine from './CreateAgencyOfferLine.vue';

export default {
  components: {
    VDropdown,
    CreateAgencyOfferLine,
    OfferCreateModalForm,
  },
  data() {
    return {
      offerCreateModalFormProps: null,
    };
  },
  computed: {
    account() {
      return this.$store.state.entities.accounts.byId[this.$route.params.accountId];
    },
    agencies() {
      return this.$store.getters['ui/clientAgencies/clientAgencies'];
    },
  },
  created() {
    this.fetchAgencies();
  },
  methods: {
    async fetchAgencies() {
      try {
        await this.$store.dispatch({
          type: 'ui/clientAgencies/load',
          clientUuid: this.$route.params.accountId,
          params: {
            include: 'account.registrations,account.paymentAccounts',
          },
        });
      } catch (error) {
        //
      }
    },
    createOffer(props) {
      this.offerCreateModalFormProps = props;
      this.$nextTick(() => {
        this.$refs.offerCreateModal.setShow(true);
      });
      this.$refs.dropdown.closeMenu();
    },
  },
};
</script>
